import { NgModule, Compiler, COMPILER_OPTIONS, Optional } from '@angular/core';
import { JitCompilerFactory } from '@angular/compiler';
import { DynamicComponentDirective } from './dynamic-component.directive';
import { DynamicComponentOptions } from './options';
export function createJitCompiler(options) {
    options = options || [];
    return new JitCompilerFactory([{ useDebug: false, useJit: true }]).createCompiler(options);
}
/**
 * Setup for DynamicComponentDirective
 *
 * ```ts
 * @NgModule({
 *   imports: [
 *     DynamicComponentModule.forRoot({
 *       imports: [CommonModule]
 *     })
 *   ],
 * })
 * class AppModule {}
 * ```
 */
var DynamicComponentModule = (function () {
    function DynamicComponentModule() {
    }
    DynamicComponentModule.forRoot = function (metadata) {
        return {
            ngModule: DynamicComponentModule,
            providers: [
                {
                    provide: Compiler, useFactory: createJitCompiler, deps: [[Optional(), COMPILER_OPTIONS]]
                },
                {
                    provide: DynamicComponentOptions, useValue: {
                        ngModuleMetadata: metadata,
                    }
                },
            ],
        };
    };
    return DynamicComponentModule;
}());
export { DynamicComponentModule };
DynamicComponentModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DynamicComponentDirective],
                exports: [DynamicComponentDirective],
            },] },
];
/** @nocollapse */
DynamicComponentModule.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/~/ng-dynamic/src/dynamic-component/module.js
// module id = ../../../../ng-dynamic/src/dynamic-component/module.js
// module chunks = 3